var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09375 6.76562L8.10938 9.57812C8.34375 9.90625 8.25 10.375 7.92188 10.6328C7.78125 10.7266 7.64062 10.7734 7.5 10.7734C7.26562 10.7734 7.03125 10.6562 6.86719 10.4453L4.42969 7H2.25V10C2.25 10.4219 1.89844 10.75 1.5 10.75C1.07812 10.75 0.75 10.4219 0.75 10V1C0.75 0.601562 1.07812 0.25 1.5 0.25H4.875C6.72656 0.25 8.25 1.77344 8.25 3.625C8.25 5.05469 7.35938 6.27344 6.09375 6.76562ZM2.25 1.77344V5.5H4.875C5.90625 5.5 6.75 4.67969 6.75 3.64844C6.75 2.59375 5.90625 1.77344 4.875 1.77344H2.25Z",
    fill: "#FF940A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/R.5e9127151151dec5a60f047ee8e69709.svg";
export { ForwardRef as ReactComponent };